/**
 * Auth Guard - Renders appropriate screen based on auth state
 * Steam-based: No login screen needed, just loading and game states
 *
 * - Loading: Show loading spinner
 * - Needs airline: Show mode selection, then create airline wizard
 * - Authenticated: Show children (the game)
 */

import React from 'react'
import { useAuth } from './AuthContext'
import CreateAirlineScreen from './CreateAirlineScreen'
import ModeSelection from '../../pages/ModeSelection'

function LoadingScreen() {
  return (
    <div className="min-h-screen flex items-center justify-center"
      style={{ background: 'linear-gradient(135deg, #0a0a0a 0%, #1a1a2e 100%)' }}>
      <div className="text-center">
        <div className="mb-4">
          <svg className="animate-spin h-12 w-12 text-[#60ffd0] mx-auto" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
          </svg>
        </div>
        <p className="text-gray-500">Loading...</p>
      </div>
    </div>
  )
}

export default function AuthGuard({ children }) {
  const { isLoading, isAuthenticated, needsAirline } = useAuth()

  // Loading state
  if (isLoading) {
    return <LoadingScreen />
  }

  // No airline yet - check if mode has been selected first
  if (needsAirline) {
    const modeSelected = localStorage.getItem('modeSelected')
    if (!modeSelected) {
      // Show mode selection before create airline
      return <ModeSelection />
    }
    return <CreateAirlineScreen />
  }

  // Fully authenticated with airline - show the game
  if (isAuthenticated) {
    return children
  }

  // Fallback to loading (shouldn't reach here with Steam auth)
  return <LoadingScreen />
}
